import { ComponentActions, ComponentState } from '../actions/ComponentActions';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { Socket } from 'socket.io-client';
import { InstanceContainer } from '../../config/binding/InstanceBinding';
import Injectables from '../../constant/Injectables';
import { dispatch } from '../store';
import { calculatePagePath } from '../actions/PageActions';
import { UserSocketSession } from '../../service/ComponentService';

const initialState: ComponentState = {
  component: null,
  id: null,
  workers: [],
  lock: null,
  selfLock: true,
  selectedComponentIds: [],
  userSessions: [],
  isDirty: false,
  globalWorkers: {},
  module: [],
};

export const componentReducer = (state = initialState, action: ReduxBaseAction<any, ComponentActions>) => {
  switch (action.type) {
    case 'ENTER_COMPONENT':
      setTimeout(() => {
        dispatch(
          calculatePagePath({
            component: action.payload.component,
            id: action.payload.id,
            disablePathCalculation: action.payload.disablePathCalculation,
          }),
        );
      }, 0);
      return { ...state, component: action.payload.component, id: action.payload.id };
    case 'LEAVE_COMPONENT':
      return { ...state, component: null, id: null, workers: [], selectedComponentIds: [], selfLock: true };
    case 'CHANGE_WORKERS':
      return { ...state, workers: action.payload };
    case 'CLEAR_GLOBAL_WORKERS':
      return { ...state, globalWorkers: {} };
    case 'ADD_GLOBAL_WORKERS': {
      const globalWorkers = { ...state.globalWorkers };
      const component = action.payload.component;
      if (globalWorkers[component] === undefined) globalWorkers[component] = [];
      const isExist = globalWorkers[component].findIndex((i) => i.componentId === action.payload.componentId) != -1;
      if (isExist) return state;
      globalWorkers[component].push(action.payload);
      return { ...state, globalWorkers };
    }
    case 'REMOVE_GLOBAL_WORKERS':
      const globalWorkersRemove = { ...state.globalWorkers };
      const component = action.payload.component;
      if (component == undefined) return state;
      const workers = globalWorkersRemove[component];
      if (workers == undefined) return state;
      const index = globalWorkersRemove[component].findIndex((i) => i.componentId === action.payload.componentId);
      if (index != -1) {
        globalWorkersRemove[component].splice(index, 1);
      }
      return { ...state, globalWorkers: globalWorkersRemove };
    case 'CHANGE_LOCK':
      const socketClient: Socket = InstanceContainer.get(Injectables.SOCKET_CLIENT);
      return { ...state, lock: action.payload, selfLock: action.payload?.id === socketClient.id };
    case 'SET_SELECTED_COMPONENTS':
      return { ...state, selectedComponentIds: action.payload };
    case 'CHANGE_USER_SESSIONS': {
      const payload: UserSocketSession = action.payload as UserSocketSession;
      const index = state.userSessions.findIndex((session: UserSocketSession) => session.id === payload.id);
      if (index === -1) {
        return { ...state, userSessions: [...state.userSessions, payload] };
      } else {
        const userSessions = [...state.userSessions];
        userSessions[index] = payload;
        return { ...state, userSessions };
      }
    }
    case 'CHANGE_IS_DIRTY':
      return { ...state, isDirty: action.payload };
    case 'SET_TENANT_MODULE':
      return {
        ...state,
        module: action.payload,
      };
    default:
      return state;
  }
};
